import hiddenColumns from "./hiddenColumns";

export const isReportColumnHidden = (columnValueKey) => {
  for (const reportColumnHiddenKey in hiddenColumns) {
    if (columnValueKey.includes(hiddenColumns[reportColumnHiddenKey])){
      return true
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/hiddenReportColumns/index.js